var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPtsFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 142,
  viewBox: "0 0 130 142",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/pts_filled.svg__filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 21,
  width: 48,
  height: 60,
  rx: 5,
  fill: "#005FF9",
  stroke: "#005FF9",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.5335 57.548C59.7915 56.6036 60.6234 55.9927 61.4352 56.0064C61.7912 55.9995 63.3544 55.9995 64.9981 56.0004C66.6418 55.9995 68.205 55.9995 68.561 56.0064C69.3728 55.9927 70.2047 56.6036 70.4628 57.548L71.097 59.8725C71.5562 59.8982 71.9219 60.272 71.9219 60.73C71.9219 61.0299 71.7644 61.2946 71.5265 61.4484C71.816 61.7036 71.9962 62.0568 71.9962 62.4512V63.7402C71.9962 63.9413 71.949 64.1312 71.8659 64.3005C71.7688 64.4913 71.7732 64.7164 71.8764 64.9037C71.9551 65.0343 71.9962 65.1882 71.9962 65.3514C71.9962 65.8481 71.6131 66.258 71.1215 66.3121V66.7478C71.1215 67.4585 70.5336 68.0368 69.8093 68.0368C69.085 68.0368 68.4972 67.4585 68.4972 66.7478V66.3572H61.4991V66.7478C61.4991 67.4585 60.9112 68.0368 60.1869 68.0368C59.4626 68.0368 58.8748 67.4585 58.8748 66.7478V66.3121C58.3831 66.258 58 65.8481 58 65.3514C58 65.1882 58.0411 65.0352 58.1137 64.9003C58.2152 64.7147 58.2187 64.493 58.1225 64.3039C58.0472 64.1312 58 63.9404 58 63.7402V62.4512C58 62.0637 58.1741 61.7165 58.4488 61.4802C58.1811 61.3333 58 61.0523 58 60.73C58 60.2557 58.3919 59.8716 58.8739 59.8716L59.5335 57.548ZM60.6563 62.8581C61.1199 62.8581 61.4961 63.2343 61.4961 63.6979C61.4961 64.1615 61.1199 64.5377 60.6563 64.5377C60.1928 64.5377 59.8166 64.1615 59.8166 63.6979C59.8166 63.2343 60.1928 62.8581 60.6563 62.8581ZM69.3368 62.8581C69.8004 62.8581 70.1766 63.2343 70.1766 63.6979C70.1766 64.1615 69.8004 64.5377 69.3368 64.5377C68.8733 64.5377 68.4971 64.1615 68.4971 63.6979C68.4971 63.2343 68.8733 62.8581 69.3368 62.8581ZM68.4972 61.0386H68.9426C69.108 61.0386 69.2647 60.9639 69.3653 60.8379C69.4668 60.7119 69.5001 60.5473 69.4572 60.3937C69.2647 59.7017 68.9637 58.6259 68.8053 58.0582C68.7431 57.8349 68.5313 57.6795 68.2898 57.6795H64.9967H61.7036C61.4621 57.6795 61.2503 57.8349 61.1882 58.0582C61.0298 58.6259 60.7287 59.7017 60.5362 60.3937C60.4933 60.5473 60.5266 60.7119 60.6281 60.8379C60.7287 60.9639 60.8854 61.0386 61.0508 61.0386H61.4962C62.0055 61.0369 67.9879 61.0369 68.4972 61.0386Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 36,
  width: 22,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 42,
  width: 16,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 30,
  width: 30,
  height: 2,
  rx: 1,
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/pts_filled.svg__filter0_d",
  x: 0,
  y: 0,
  width: 130,
  height: 142,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgPtsFilled as ReactComponent };